import { render, staticRenderFns } from "./cardLedgerC.vue?vue&type=template&id=6b744045&scoped=true"
import script from "./cardLedgerC.vue?vue&type=script&lang=js"
export * from "./cardLedgerC.vue?vue&type=script&lang=js"
import style0 from "./cardLedgerC.vue?vue&type=style&index=0&id=6b744045&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b744045",
  null
  
)

export default component.exports